import { getFirestore, doc, collection, getDocs, getDoc } from 'firebase/firestore';
import app                      from '../firebase';
import { useEffect, useState }  from 'react';
import homemoto                 from '../media/logo.png';
import { useNavigate }          from 'react-router-dom';

import { IoFastFood }           from 'react-icons/io5';
import { RiBuilding2Fill }      from 'react-icons/ri';
import { GiShoppingCart }       from 'react-icons/gi';
import { GiGears }              from 'react-icons/gi';
import { AiFillWechat }         from 'react-icons/ai';
import { MdChair }              from 'react-icons/md';



export default function Header() {

    const navigate = useNavigate();
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });
    const [isUser, setIsUser] = useState(false);
    const [user, setUser] = useState();

    const [profile, setProfile]   = useState();

    // cart
    const [cart, setCart] = useState();

    const [keywords, setKeywords] = useState();
    const [category, setCategory] = useState();

    const getCart = () => {
        setCart(JSON.parse(localStorage.getItem('cart')));
    }

    const getProfile = () => {
        if (localStorage.getItem('userId')) {
            getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
            .then(result => {
                setProfile([result.id, result.data()])
            })
        }
    }

    const getUnreadMessages = () => {
        //
    }


    const [productCategories, setProductCategories]     = useState();
    const [propertyCategories, setPropertyCategories]   = useState();
    const [serviceCategories, setServiceCategories]     = useState();

    const search = () => {
        if (category && keywords) {
            localStorage.setItem('search_bullet', JSON.stringify({ category, keywords })); // keywords in array form
            window.location.replace('/search');
        } else alert('Please select a category and put keywords!');
        
        return;
    }

    const getProductCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'product_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setProductCategories(x);
    }

    const getPropertyCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'property_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setPropertyCategories(x);
    }

    const getServiceCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'service_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setServiceCategories(x);
    }

    useEffect(() => {
        getProfile();
        getUnreadMessages();
        getProductCategories();
        getPropertyCategories();
        getServiceCategories();
        console.log('Working');
    }, []);

    return(
        <>
            {/* desktop view */}
            <div className="container-fluid d-none d-md-flex align-items-center justify-content-between bg-success text-light px-4 py-1">
                <a href="/profile">Sell on Homemoto</a>
                <a href="/cart"><i className="bi-cart"></i> Cart: {cart && cart.items.length} - {cart && formatter.format(cart.total)} </a>
            </div>

            <nav className="d-none d-md-block navbar navbar-expand-lg navbar-light sticky-top bg-light px-4">
                <div className="container-fluid">
                    
                    <img
                        className="navbar-brand"
                        src={homemoto}
                        style={{ width: 100 }}
                        alt="Homemoto"
                        role="button"
                        onClick={() => window.location.replace('/')}
                    />
                    
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item mx-3">
                                <MdChair className="d-block mx-auto fs-1 text-success" role="button" onClick={() => navigate('/products')} />
                                <small className="d-block fw-bold text-success">Products</small>
                            </li>

                            <li className="nav-item mx-3">
                                <RiBuilding2Fill className="d-block mx-auto fs-1 text-success" role="button" onClick={() => navigate('/properties')} />
                                <small className="d-block fw-bold text-success">Properties</small>
                            </li>

                            <li className="nav-item mx-3">
                                <GiGears className="d-block mx-auto fs-1 text-success" role="button" onClick={() => navigate('/services')} />
                                <small className="d-block fw-bold text-success">Services</small>
                            </li>

                            <li className="nav-item mx-3">
                                <IoFastFood className="d-block mx-auto fs-1 text-success" role="button" onClick={() => navigate('/foods')} />
                                <small className="d-block fw-bold text-success">Foods</small>
                            </li>

                            <li className="nav-item mx-3">
                                <AiFillWechat className="d-block mx-auto fs-1 text-success" role="button" onClick={() => navigate('/conversations')} />
                                <small className="d-block fw-bold text-success">Messages</small>
                            </li>

                            <li className="nav-item me-4">
                                <GiShoppingCart className="d-block mx-auto fs-1 text-success" role="button" onClick={() => navigate('/cart')} />
                                <small className="d-block fw-bold text-success">Cart</small>
                            </li>

                            {
                                profile ? (
                                    <li className="nav-item">

                                        <div className="dropdown">

                                            <img
                                                src={profile && profile[1].picture ? profile[1].picture:homemoto}
                                                className="shadow rounded-circle"
                                                style={{ width: 54, height: 54 }}
                                                alt="Homemoto"
                                                role="button"
                                                id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"
                                            />

                                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                                <li><a className="dropdown-item" href="/profile"><i className='bi-person-circle me-2'></i>Profile</a></li>
                                                {/* <li><hr /></li> */}
                                                <li><a className="dropdown-item text-danger" href="/logout"><i className='bi-box-arrow-left me-2'></i>Logout</a></li>
                                            </ul>
                                        </div>
                                    </li>
                                ):(
                                    <li className="nav-item">
                                        <button className="btn btn-dark mt-2" onClick={() => navigate('/login')}>Login</button>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </nav>

            {/* mobile view */}
            <div className="sticky-top">
                <div className="container-fluid bg-success text-light d-flex d-md-none align-items-center justify-content-between py-1">
                    <a href="/products" className="fw-bold">Products</a>
                    <a href="/foods" className="fw-bold">Foods</a>
                    <a href="/properties" className="fw-bold">Properties</a>
                    <a href="/services" className="fw-bold">Services</a>
                </div>

                <div className="container-fluid bg-light d-flex d-md-none align-items-center justify-content-between py-2">
                    <i className="bi-search" role="button" data-bs-toggle="modal" data-bs-target="#exampleModal"></i>
                    <img src={homemoto}  className="img-fluid rounded-circle" style={{ width: 36, height: 36 }} alt="" />
                </div>
            </div>

            {/* modal */}

            <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">

                            <input
                                type="text"
                                className="form-control rounded-pill mb-2"
                                onChange={data => setKeywords(data.target.value)}
                            />

                            <select className="form-select rounded-pill mb-2" style={{ width: '40%' }} onChange={data => setCategory(data.target.value)}>
                                <option value="" selected disabled>Category List</option>
                                <option value="" disabled>Product category</option>
                                { productCategories && productCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                                <option value="" disabled>Property Categories</option>
                                { propertyCategories && propertyCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                                <option value="" disabled>Service Categories</option>
                                { serviceCategories && serviceCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                            </select>

                            <button className="btn btn-dark rounded-pill w-100" onClick={search}>
                                <i className="bi-search me-1"></i>
                                Search
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}